// Monument + platform + roadmap data. User-provided assets from problem statement.

export const USER_ASSETS = {
  // Wide diagonal before/after: temple ruin (grey) → vibrant restored temple with people
  splitTemple:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_d2a487c7-9f5f-4d70-9cae-c2688eaf735d/artifacts/bcrqb3z8_Screenshot%202026-07-22%20at%201.01.09%20PM.png",
  // Person in VR headset viewing golden holographic city over ruins
  vrOverlay:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_d2a487c7-9f5f-4d70-9cae-c2688eaf735d/artifacts/5vjxkjyc_Screenshot%202026-07-22%20at%201.01.34%20PM.png",
  // Panoramic wide ruin→restored temple complex fade
  panoramic:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_d2a487c7-9f5f-4d70-9cae-c2688eaf735d/artifacts/6k3el8zn_Screenshot%202026-07-22%20at%201.02.10%20PM.webp",
  // Vision chapter — a person in VR headset viewing a golden holographic reconstruction over ruins
  paradox:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_monument-reimagined/artifacts/v38ezs3c_vision.png",
  // Step I — Arrival & Alignment: visitors at the physical monument
  arrival:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_monument-reimagined/artifacts/5abrqhw9_Arrival.png",
  // Step II — Restoration Overlay: ruin transforming into golden reconstruction
  overlay:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_monument-reimagined/artifacts/4i3piom8_Overlay.png",
  // Step III — Total Immersion: living restored world with soldiers/markets
  totalImmersion:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_monument-reimagined/artifacts/rcsgmxtf_Total_Immersive.png",
};

export const CHANNELS = [
  {
    n: "01",
    title: "On-Site Immersive VR",
    body: "Lightweight headsets deployed at heritage sites. Spatial anchors register the monument in real space — reconstruction snaps to reality with sub-centimeter precision.",
    accent: "Flagship channel",
  },
  {
    n: "02",
    title: "Mobile Augmented Reality",
    body: "Every visitor's phone becomes a portal. Point, and the ruin restores itself in the viewfinder — accessible to millions without additional hardware.",
    accent: "Scalable reach",
  },
  {
    n: "03",
    title: "International Digital Access",
    body: "Global audiences step into Indian heritage from anywhere. A premium ticketed layer for diaspora, scholars, and tourists worldwide.",
    accent: "Soft-power layer",
  },
  {
    n: "04",
    title: "Educational Deployment",
    body: "Classrooms across Bharat receive curriculum-linked immersive modules aligned with the National Education Policy — history taught by walking through it.",
    accent: "NEP-aligned",
  },
  {
    n: "05",
    title: "Guided Historical Journeys",
    body: "Authored narratives voiced by historians, dramaturges, and regional scholars — an editorial layer atop the reconstruction.",
    accent: "Curated storytelling",
  },
  {
    n: "06",
    title: "Museum Installations",
    body: "Permanent immersive rooms in flagship museums translating archival collections into standing, breathing environments.",
    accent: "Institutional",
  },
];

export const PHASES = [
  {
    n: "Phase 01",
    title: "Flagship Pilot",
    body: "Amer Fort. A single reference deployment engineered end-to-end — the proof of civilisational immersion.",
  },
  {
    n: "Phase 02",
    title: "The Core Five",
    body: "Hampi · Raigad · Dholavira · Konark · Ajanta. Five civilisational nodes across regions and eras.",
  },
  {
    n: "Phase 03",
    title: "National Presence",
    body: "Twenty-five monuments spanning UNESCO sites, state icons, and forgotten wonders — a distributed digital heritage lattice.",
  },
  {
    n: "Phase 04",
    title: "The ReplayEra Network",
    body: "100+ destinations. A sovereign platform exporting Indian civilisation as global soft power.",
  },
];

export const VISITOR_STEPS = [
  {
    n: "I",
    title: "Arrival & Alignment",
    body: "You stand at the physical monument. The fragmented site is before you. A lightweight headset is placed — spatial calibration begins in a heartbeat.",
    image: USER_ASSETS.arrival,
  },
  {
    n: "II",
    title: "The Restoration Overlay",
    body: "Spatial AI maps the terrain. Walls rise. Frescoes regain colour. Domes complete themselves. The monument reassembles around you.",
    image: USER_ASSETS.overlay,
  },
  {
    n: "III",
    title: "Total Immersion",
    body: "Markets stir. Priests chant. Soldiers patrol the ramparts. Temples resonate with ritual. You are no longer looking at history — you are inside it.",
    image: USER_ASSETS.totalImmersion,
  },
];

// PRASHAD removed per updated brand direction
export const VIKSIT_PILLARS = [
  { name: "Dekho Apna Desh", note: "Domestic tourism ignition" },
  { name: "National Education Policy", note: "Experiential learning" },
  { name: "Ek Bharat Shreshtha Bharat", note: "Cultural unity" },
];
